import { resolveHomeHostHintRedirect } from '#pplx/frontend/apps/ask/auth/homeHostHintRedirect.js';
import { resolveHomeHostRedirect } from '#pplx/frontend/apps/ask/auth/resolveHomeHostRedirect.js';
import { canonicalizeLegacyPermalinkPath, canonicalizeLegacyPermalinkUrl, } from '#pplx/frontend/apps/ask/permalink-slug/canonicalizeLegacyPermalink.js';
import { getWindowOrigin } from '#pplx/frontend/common/location.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { redirectWindow } from '#pplx/frontend/platform-components/redirectWindow.js';
/**
 * Bootstrap-time home-host routing. Call with the *resolved* session (not the cached
 * one), before rendering or preloading anything.
 *
 * Enterprise cookies are host-only, so any request a consumer-host page issues for
 * an enterprise user goes out anonymous and fails closed on BYOK data. Deciding the
 * redirect before anything boots means no page code, preload, or thread loader runs
 * on the wrong host.
 *
 *   - Signed in: the session's `home_host` claim is authoritative.
 *   - Anonymous: fall back to the forgeable, allowlisted `pplx.home-host` hint.
 *
 * Returns true when a redirect was issued; the caller must then not boot the app.
 * Any failure returns false so routing degrades to "off", never a white screen.
 */
export function redirectToHomeHostBeforeBoot(session) {
    try {
        // TODO: Combine permalink canonicalization with the cross-host navigation so
        // redirected legacy URLs update the browser location only once.
        canonicalizeLegacyPermalinkUrl(window.location, window.history);
        const location = {
            currentOrigin: getWindowOrigin({ intent: 'document' }),
            // Keep the redirect safe even if history.replaceState is unavailable.
            pathname: canonicalizeLegacyPermalinkPath(window.location.pathname),
            search: window.location.search,
        };
        const target = session?.user
            ? resolveHomeHostRedirect({ homeHost: session.user.home_host, ...location })
            : resolveHomeHostHintRedirect(location);
        if (!target)
            return false;
        redirectWindow(target, session?.user ? 'home host routing' : 'home host hint routing');
        return true;
    }
    catch (error) {
        logger.error(new Error('Home host bootstrap routing failed'), { error });
        return false;
    }
}
//# sourceMappingURL=redirectToHomeHostBeforeBoot.js.map